import axios from "axios";

const getShopRegionsFromUrl = url => {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "get",
      responseType: "json"
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => reject(error));
  });
};

export default getShopRegionsFromUrl;
